import { useSyncExternalStore } from "react";

const TICK_MS = 1000;

let intervalId: ReturnType<typeof setInterval> | null = null;
const listeners = new Set<() => void>();

const tick = () => {
  listeners.forEach((listener) => listener());
};

// One interval for every countdown on the page, so they can't drift apart.
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  if (listeners.size === 1) {
    intervalId = setInterval(tick, TICK_MS);
  }

  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };
};

// `select` runs every tick, but React only re-renders if its return value
// actually changed - so a countdown hours away doesn't re-render each second
const useNow = <T,>(select: (nowMs: number) => T): T =>
  useSyncExternalStore(subscribe, () => select(Date.now()));

export { useNow };
